import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    output,
} from '@angular/core';
import { CommunityType } from '@interacta-shared/util-caronte';
import { selectCommunityTree } from '@interacta/data-access-community-tree';
import { ICommunity } from '@interacta/util-community';
import { CommunityActions } from '@modules/communities/store';
import { selectRecentCommunities } from '@modules/communities/store/community/community.selectors';
import { CommunitySelectionDialogComponent } from '@modules/sidebar/components/community-selection-dialog/community-selection-dialog.component';
import { Store } from '@ngrx/store';

@Component({
    selector: 'interacta-i-lab-interop-community-selection-dialog',
    templateUrl: './i-lab-interop-community-selection-dialog.component.html',
    imports: [CommunitySelectionDialogComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ILabInteropCommunitySelectionDialogComponent {
    private readonly store = inject(Store);

    readonly selectCommunity = output<ICommunity | null>();

    readonly CommunityType = CommunityType;

    private readonly communityTree =
        this.store.selectSignal(selectCommunityTree);

    readonly workspaces = computed(
        () => this.communityTree()?.workspaceList ?? [],
    );

    readonly recentCommunities = this.store.selectSignal(
        selectRecentCommunities,
    );

    constructor() {
        this.store.dispatch(CommunityActions.getRecentCommunities());
    }
}
